import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import InventoryRecordStore from '../../stores/InventoryRecordStore';
import InventorySearch from '../../components/InventorySearch';
import styles from './index.sass';

class MarketingIndexContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSearchLink: 'all'
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickSearchButton(e) {
    e.stopPropagation();
    e.preventDefault();
    this.refs.inventorySearch.refs.wrappedElement.handleOnClickSearchButton();
  }

  handleOnClickSearchLink(link) {
    this.setState({activeSearchLink: link});
  }

  render() {
    let numBottles = this.props.stats ? formatNumber(this.props.stats.distinct_wine_sku_ids) : 'thousands of';
    let {activeSearchLink} = this.state;
    let inventorySearchProps = {
      ref: 'inventorySearch',
      className: styles.inventorySearch,
      currentRoute: this.props.currentRoute,
      searchInputOpen: true
    };
    if (activeSearchLink !== 'all') {
      inventorySearchProps.additionalFilters = [{type: 'alcohol_type', value: activeSearchLink}];
    }
    let searchButtonProps = {
      className: styles.searchButton,
      onClick: this.handleOnClickSearchButton.bind(this)
    };
    let allSearchLinkProps = {
      className: `${styles.searchLink} ${activeSearchLink === 'all' ? styles.active : ''}`,
      onClick: this.handleOnClickSearchLink.bind(this, 'all')
    };
    let wineSearchLinkProps = {
      className: `${styles.searchLink} ${activeSearchLink === 'wine' ? styles.active : ''}`,
      onClick: this.handleOnClickSearchLink.bind(this, 'wine')
    };
    let beerSearchLinkProps = {
      className: `${styles.searchLink} ${activeSearchLink === 'beer' ? styles.active : ''}`,
      onClick: this.handleOnClickSearchLink.bind(this, 'beer')
    };
    let spiritsSearchLinkProps = {
      className: `${styles.searchLink} ${activeSearchLink === 'spirits' ? styles.active : ''}`,
      onClick: this.handleOnClickSearchLink.bind(this, 'spirits')
    };

    return (
      <div className={styles.container}>
        <div className={styles.mainSection}>
          <div className={styles.inner} style={{overflow: 'hidden'}}>
            <ul className={styles.searchLinks}>
              <li><button {...allSearchLinkProps}>All</button></li>
              <li><button {...wineSearchLinkProps}>Wine</button></li>
              <li><button {...beerSearchLinkProps}>Beer</button></li>
              <li><button {...spiritsSearchLinkProps}>Spirits</button></li>
            </ul>
            <div className={styles.searchContainer}>
              <InventorySearch {...inventorySearchProps} />
              <button {...searchButtonProps}>Search</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MarketingIndexContainer = connectToStores(MarketingIndexContainer, [InventoryRecordStore], (context, props) => {
  return {
    stats: context.getStore(InventoryRecordStore).getStats()
  };
});

export default MarketingIndexContainer;

function formatNumber(num) {
  return (num + '').replace(/(\d)(?=(\d{3})+$)/g, '$1,');
}



// WEBPACK FOOTER //
// banquet/containers/MarketingIndexContainer/index.js